// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--H1Xo2";
export var hero__media = "hero-module--hero__media--Eqb8P";
export var hero__title = "hero-module--hero__title--TFhVm";
export var hero__gradient = "hero-module--hero__gradient--wzaUL";
export var hero__gradient_tablet = "hero-module--hero__gradient_tablet--zdxvz";
export var hero__gradient_mobile = "hero-module--hero__gradient_mobile--6rKV4";
export var hero_textLeft = "hero-module--hero_text-left--a5fTZ";
export var hero__button = "hero-module--hero__button--JnouS";